/* eslint-disable */

import { axiosInstanceLive } from 'instance/Axios';
import { handleCatchError } from 'utils/CatchHandler';

const commonEndPoint = 'api/V2/';
let merchantEmpID;

const handleApiRequest = async (method, endpoint, payload = null) => {
    try {
        const response =
            method === 'GET'
                ? await merchantCommonGetRequest(endpoint, payload) // Pass params for GET
                : await merchantCommonPost(endpoint, payload); // Pass body for POST

        return response;
    } catch (error) {
        console.error('API Error:', error);
        return null;
    }
};
export const merchantCommonPost = async (apiEndPoint, payload) => {
    const latitude = localStorage.getItem('latitude');
    const longitude = localStorage.getItem('longitude');
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    // const domainName = window.location.protocol + '//' + window.location.hostname;
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const isFormData = payload instanceof FormData;
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        ...(isFormData ? {} : { 'Content-Type': 'application/json' }),
        // 'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.post(
            endPoint,
            payload,

            {
                headers
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};
export const merchantCommonGetRequest = async (apiEndPoint, params) => {
    const latitude = localStorage.getItem('latitude');
    const longitude = localStorage.getItem('longitude');
    const isEmployee = localStorage.getItem('isEmployee');
    if (isEmployee === 'true') {
        merchantEmpID = localStorage.getItem('empId');
    }
    const endPoint = commonEndPoint + apiEndPoint;
    const token = localStorage.getItem('token');
    const headers = {
        Authorization: `Bearer ${token}`,
        'Header-Merchant-Employee': merchantEmpID,
        'Content-Type': 'application/json',
        'X-Latitude': latitude,
        'X-Longitude': longitude
    };
    try {
        const response = await axiosInstanceLive.get(
            endPoint,

            {
                headers,
                params
            }
        );
        return response;
    } catch (error) {
        console.log(error);
        handleCatchError(error);
        return error;
    }
};

export const GET_API_ENDPOINTS = {
    checkPermission: 'merchants/checkPermission',
    rdService: 'merchants/rdService',
    // Add more endpoints as needed
    //bankList
    bankList: 'moneytransfer/iserveubanklist',
    //merchant employee apis
    merchantEmployeeList: 'merchants/employee/list',
    //PANCARD APIs
    getStateDist: 'moneytransfer/getStateDist',
    //HELPING TOOL API  >>>>
    helpingTool: 'merchants/helpingTool',
    //Government services search
    getGovtServices: 'moneytransfer/getGovtServices',
    //Other api end points
    getBcCertificate: 'merchants/getBcCertificate',
    //Bill/Reciept
    billList: 'merchants/getBillReceipt',
    //BCAGREEMENT
    bcCertificateGetCErtificate: 'merchants/getBcCertificate',
    //EDIT PROFILE
    addressDetails: 'moneytransfer/address_details',
    getProfile: 'merchants/getProfile',
    //LOGOUT
    logout: 'moneytransfer/logoutSession',
    getState: 'icicMtm/merchants/GetState',
    convertionSlab: 'moneytransfer/convertionSlab',
    getIciciState: 'onboarding/getIciciState',
    getFaq: 'faq',
    mdrCharge: 'merchants/mdrCharges',
    mobileBankingList: 'merchants/mobile-banking/users',
    rekycOtpSend: 'merchants/rekyc/OtpSend',
    states: 'merchants/states',
    district: 'merchants/district',
    city: 'merchants/fetchCity',
    fetchMarketPlaceServices: 'merchants/marketplace/fetchMarket',
    fetchMarketPlaceCategory: 'merchants/marketplace/fetchMarketCategory',
    homePageInformations: 'merchants/home-settings'
};
export const POST_API_ENDPOINTS = {
    GETCheckPermission: 'merchants/checkPermission',
    checkMerchantOrBC: 'merchants/checkIsMerchant',
    convertBC: 'merchants/bcConvertion',
    searchServices: 'moneytransfer/search/GovtServices',
    getGovtMultiServices: 'moneytransfer/getGovtMultiServices',
    getGovtSubServices: 'moneytransfer/getGovtSubServices',
    faqSearch: 'faq/search',
    updateBcAgentAccount: 'merchants/updateBcAgentAccount',
    agreePolicy: 'moneytransfer/terms/agreePolicy',
    //merchant employee apis>>>>>
    addMerchantEmployee: 'merchants/employee/add',
    // merchant employee apis ENDS here>>>>>

    //PANCARD APIS>>>>>>>>>
    indexverifyPancard: 'merchants/pancard/indexverifyPancard',
    checkStatusregister: 'merchants/pancard/checkStatusregister',
    registerPandcard: 'merchants/pancard/Register',
    viewPanRegister: 'merchants/pancard/viewPanRegister',
    editRegister: 'merchants/pancard/editRegister',
    CouponBuy: 'merchants/pancard/CouponBuy',
    viewCouponList: 'merchants/pancard/viewCouponList',
    CouponStatusCheck: 'merchants/pancard/CouponStatusCheck',
    //PANCARD APIS ENDS HERE>>>>>>>>>

    //OTHER API END POINTS>>>>>
    uploadBcCertificate: 'merchants/uploadBcCertificate',
    getBalance: 'moneytransfer/getBalance',
    //UPIATM APIS>>>>>>>>>
    subscriptionCheck: 'merchants/upiATM/UPIATMsubscriptionCheck',
    subscriptionHistory: 'merchants/paysprint/upiATM/history',
    subscriptionOtpSend: 'merchants/paysprint/upiATM/sendOTP',
    subscriptionStatusCheck: 'merchants/paysprint/upiATM/statusCheck',
    subscriptionOtpVerification: 'merchants/paysprint/upiATM/verifyOTP',
    unSubscription: 'merchants/upiATM/Unsubscription',
    subscriptionOtp: 'merchants/upiATM/subscriptionOTP',
    subscription: 'merchants/upiATM/subscription',
    //UPIATM APIS ENDS HERE>>>>>>>>>
    //BILL/RECIEPT APIS>>>>>>>>>
    billInvoice: 'merchants/getBillReceiptDetails',
    billReceipt: 'merchants/storeBillReceipt',
    //BCAGREEMENT
    bcUploadCertificate: 'merchants/uploadBcCertificate',
    getBcAgreement: 'moneytransfer/get-bc-agreement',
    signBcAgreement: 'moneytransfer/sign-bc-agreement',
    //BC conversion without esign for whitelabel
    bcConvertWithoutEsign: 'moneytransfer/whitelabel-convert-bc',
    //EDIT PROFILE
    editProfile: 'merchants/updateProfile',
    otpSend: 'merchants/otpSend',
    otpVerify: 'merchants/otpVerify',
    setOtpNumber: 'merchants/storeOtpNumber',
    changePassword: 'merchants/MerchantChangePassword',
    changeMpin: 'moneytransfer/merchant/ChangeMpin',
    //ICICI Registration
    iciciRegistrationStep1: 'icicMtm/merchants/StoreicicAtmWithStep',
    //MPIN
    checkMpin: 'moneytransfer/merchant/CheckMpin',
    statusMpin: 'moneytransfer/merchant/StatusMpin',
    setMpin: 'moneytransfer/merchant/SetMpin',
    getOtpMpin: 'moneytransfer/merchant/GenerateOTPMpin',
    loginTypeChanger: 'moneytransfer/merchant/updateOtp',
    //HELPING TOOL API END HERE>>>>>>
    //LATEST INSURANCE-FEB-2024
    webinsurance: 'moneytransfer/merchants/webinsurance',
    insureanceReport: 'merchants/InsurancePolicyList',
    //INSURANCE COMMISSION CLAIM APIS
    insuranceCompanyList: 'moneytransfer/ListInsuranceCompany',
    storeCommissionRequest: 'moneytransfer/StoreCommissionrequest',
    commissionRequestHistory: 'moneytransfer/History/Commissionrequest',
    //MULTI-PURPOSE ONBOARDING API START>>>>>>>
    getOnboardingDetails: 'onboarding/getOnboardingDetails',
    multiPurposeOnboard: 'onboarding/store',
    //MULTI-PURPOSE ONBOARDING API END>>>>>>>

    //PASSWORD RESET WITH EMAIL APIS START>>>>>>>>>>>
    resetPasswordStep1afterLogin: 'moneytransfer/verifyResetPasswordstep1New',
    verifyOtpResetPasswordAfterLogin: 'moneytransfer/verifyOtpResetPasswordNew',
    ResetConfirmPasswordAfterLogin: 'moneytransfer/ResetConfirmPasswordNew',
    //PASSWORD RESET WITH EMAIL APIS END>>>>>>>>>>>

    //PREMIUM BC CONVERSION APIS START >>>>>>>>>
    premiumBCCharges: 'moneytransfer/bctopremium/charges',
    premiumBCChargesNew: 'moneytransfer/bctopremium/chargesV2',
    premiumBcUpdateViaWallet: 'moneytransfer/bctopremium/Updatevia/wallet',
    convertBackToBC: 'merchants/premiumToBcConversion',
    //PREMIUM BC CONVERSION APIS END >>>>>>>>>
    //UPLOAD PROFILE PHOTO START >>>>>>>>>>>
    profilePhotoUpload: 'moneytransfer/addProfileImg',
    //BUSINESS PROOF UPLOAD APIS START>>>>>>>>>>>>>
    businessProofCheck: 'moneytransfer/getstatus/Bussinessproff',
    uploadBusinessProof: 'moneytransfer/StoreUpdate/Bussinessproff',
    //BUSINESS PROOF UPLOAD APIS END>>>>>>>>>>>>>
    themeModeUpdate: 'merchants/updateDarkMode',
    bbpsBiller: 'merchants/getBbpsBillerReport',
    //mobile banking
    mobileBankingRegistration: 'merchants/mobile-banking/signup',
    mobileBankingView: 'merchants/mobile-banking/view-user',
    mobileBankingUserTransactions: 'merchants/mobile-banking/user-transactions',
    mobileBankingAllTransactions: 'merchants/mobile-banking/all-transactions',
    excelUploadMb: 'merchants/mobile-banking/upload-excelbalance',
    //credit api
    creditApi: 'merchants/Creditbalancetodistributor',
    //REWARD APIS>>>>>>>>>>>>>>>>>>>>>>>>
    getReward: 'merchants/rewards/getItems',
    spinResult: 'merchants/rewards/result',
    //Re-KYC>>>>>
    reKycOtpVerify: 'merchants/rekyc/OtpVerify',
    reKycSubmit: 'merchants/rekyc/submit',

    //Bank accounts sections>>>>>>>>
    AddnewbankAccount: 'moneytransfer/AddnewbankAccount',
    ListbankAccount: 'moneytransfer/ListbankAccount',
    SetPrimarybankAccount: 'moneytransfer/SetPrimarybankAccount',
    DeletebankAccount: 'moneytransfer/DeletebankAccount',
    listAllAEPSTransactions: 'moneytransfer/Superagent/listAllAEPSTransactions',
    //List batches create>>>>>>>>>>>
    listBatches: 'moneytransfer/Transactions/ListCreateBatches',
    checkCreateBatch: 'moneytransfer/Transactions/checkCreateBatches',
    createBatches: 'moneytransfer/Transactions/createBatches',
    //autosettlement enable>>>>
    UpdateAutoSettlementStatus: 'moneytransfer/UpdateAutoSettlementStatus',
    //Profile summary api>>>>>>>>>>>>>>>>>>>>>>>>
    profileSummmary: 'moneytransfer/profileSummary',
    todaySummary: 'moneytransfer/todaySummary',
    //transaction management for quickly pay apis>>>>>
    addTransaction: 'merchants/quicklypay/addAccountDetails',
    listTransactions: 'merchants/quicklypay/listDetails',
    pennyDropFundManagement: 'merchants/quicklypay/pennyDrop',
    premiumNotifyResponse: 'merchants/premium-bc-consent',
    signRentalAgreement: 'moneytransfer/sign-rental-agreement',
    getRentalAgreement: 'moneytransfer/get-rental-agreement',
    digiloan: 'merchants/digiloan/addUser',
    listLoan: 'merchants/digiloan/userList',
    checkRegistrationStatus: 'moneytransfer/Svantantr/Check/register',
    svantantrInsuranceRegistration: 'moneytransfer/Svantantr/Storeregister',
    createLead: 'moneytransfer/Svantantr/CreateLead',
    leadList: 'moneytransfer/Svantantr/Leadlist',
    //marketplace>>>
    marketPlaceSendOtp: 'merchants/marketplace/sendOtp',
    marketPlaceVerifyOtp: 'merchants/marketplace/VerifyOTP',
    storeMarketCustomer: 'merchants/marketplace/storeMarketCustomer',
    //gold loan>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>.
    goldLead: 'moneytransfer/MFLGOLD/CreateLead',
    goldLeadList: 'moneytransfer/MFLGOLD/Leadlist',
    //Fingpay CMS >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    fingpayCmsAuthLink: 'moneytransfer/FingpayCMS/AuthLink',
    fingpayCmsListTransactions: 'moneytransfer/FingpayCMS/ListTransactions',
    checkFingpayCmsStatus: 'moneytransfer/FingpayCMS/checkRegister',
    registerFingpayCms: 'moneytransfer/FingpayCMS/UserRegister',
    //travel portal>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    travelRedirect: 'moneytransfer/TRAVELPORTAL/getLink',
    travelList: 'moneytransfer/TRAVELPORTAL/List',
    merchantWalletTransactions: 'merchants/getMerchantTransactions',
    chatbotToken: 'merchants/chatbot-token'
};
//>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>

export const rdServiceLinksApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.rdService, payload);
export const merchantEmployeeListApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.merchantEmployeeList, payload);
export const checkMerchantOrBCAPI = async (payload) => {
    const loginRole = localStorage.getItem('role');
    if (loginRole === 'merchants') {
        return handleApiRequest('POST', POST_API_ENDPOINTS.checkMerchantOrBC, payload);
    }
    return null;
};
export const convertAsBc = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.convertBC, payload);
export const searchCommonServices = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.searchServices, payload);
export const searchGovtMultiServices = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getGovtMultiServices, payload);
export const getGovtSubServicesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getGovtSubServices, payload);
export const faqSearchApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.faqSearch, payload);
export const updateBcAgentAccountApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.updateBcAgentAccount, payload);
export const agreePolicyApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.agreePolicy, payload);
export const addMerchantEmployeeApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addMerchantEmployee, payload);
export const getStateDistApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.getStateDist, payload);
export const indexverifyPancardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.indexverifyPancard, payload);
export const checkRegisterStatusApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkStatusregister, payload);
export const pancardRegistrationApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.registerPandcard, payload);
export const viewPanRegisterApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewPanRegister, payload);
export const editRegisterApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editRegister, payload);
export const couponBuyApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.CouponBuy, payload);
export const viewCouponListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.viewCouponList, payload);
export const couponStatusCheckApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.CouponStatusCheck, payload);
export const upiAtmSubscriptionCheck = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionCheck, payload);
export const upiAtmHistory = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionHistory, payload);
export const helpingToolApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.helpingTool, payload);
export const getGovtServicesApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.getGovtServices, payload);
export const conversionSlabApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.convertionSlab, payload);
export const getBcCertificateApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.getBcCertificate, payload);
export const uploadBcCertificateApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.uploadBcCertificate, payload);
export const upiAtmOtp = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionOtpSend, payload);
export const upiAtmStatusCheck = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionStatusCheck, payload);
export const upiAtmOtpVerification = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionOtpVerification, payload);
export const upiAtmUnsubscription = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.unSubscription, payload);
export const upiAtmSubscriptionOtp = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscriptionOtp, payload);
export const upiAtmSubscription = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.subscription, payload);
export const billInvoice = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.billInvoice, payload);
export const billList = () => handleApiRequest('GET', GET_API_ENDPOINTS.billList);
export const billReceipt = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.billReceipt, payload);
export const editProfile = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.editProfile, payload);
export const addressDetailsGet = () => handleApiRequest('GET', GET_API_ENDPOINTS.addressDetails);
export const getProfile = () => handleApiRequest('GET', GET_API_ENDPOINTS.getProfile);
export const logOutGet = () => handleApiRequest('GET', GET_API_ENDPOINTS.logout);
export const getOtp = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.otpSend, payload);
export const otpVerify = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.otpVerify, payload);
export const setOtpNumber = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.setOtpNumber, payload);
export const setChangePassword = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.changePassword, payload);
export const setChangeMpin = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.changeMpin, payload);
export const iciciStep1 = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.iciciRegistrationStep1, payload);
export const getState = () => handleApiRequest('GET', GET_API_ENDPOINTS.getState);
export const checkMpin = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkMpin, payload);
export const setMpins = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.setMpin, payload);
export const getMpinOtp = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getOtpMpin, payload);
export const webinsuranceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.webinsurance, payload);
export const getOnboardingDetailsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getOnboardingDetails, payload);
export const getIciciStateApi = () => handleApiRequest('GET', GET_API_ENDPOINTS.getIciciState);
export const getDefaultFaq = () => handleApiRequest('GET', GET_API_ENDPOINTS.getFaq);
export const multiPurposeOnboardApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.multiPurposeOnboard, payload);
export const resetPasswordStep1AfterLoginApi = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.resetPasswordStep1afterLogin, payload);
export const verifyOtpResetPasswordAfterLoginApi = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.verifyOtpResetPasswordAfterLogin, payload);
export const ResetConfirmPasswordAfterLoginApi = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.ResetConfirmPasswordAfterLogin, payload);
export const getBalanceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getBalance, payload);
export const getBCAgreementHtml = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getBcAgreement, payload);
export const signBcAgreementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.signBcAgreement, payload);
export const bcConvertWithoutEsignApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.bcConvertWithoutEsign, payload);
export const getRewardsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getReward, payload);
export const insuranceListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.insureanceReport, payload);
export const insuranceCompanyListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.insuranceCompanyList, payload);
export const storeCommssionClaimApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeCommissionRequest, payload);
export const commissionRequestHistoryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.commissionRequestHistory, payload);
export const getPremiumBcChargesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.premiumBCCharges, payload);
export const premiumBcUpdateViaWalletApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.premiumBcUpdateViaWallet, payload);
export const convertPremiumBackToBC = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.convertBackToBC, payload);
export const profilePhotoUploadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.profilePhotoUpload, payload);
export const checkBusinessProofStatusAPi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.businessProofCheck, payload);
export const uploadBusinessProofAPi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.uploadBusinessProof, payload);
export const updateThemeMode = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.themeModeUpdate, payload);
export const getMdrChargesApi = () => handleApiRequest('GET', GET_API_ENDPOINTS.mdrCharge);
export const bbpsBillerReportApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.bbpsBiller, payload);
export const mobileBankingRegistrationApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.mobileBankingRegistration, payload);
export const mobileBankingListApi = () => handleApiRequest('GET', GET_API_ENDPOINTS.mobileBankingList);
export const mobileBankingViewApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.mobileBankingView, payload);
export const mobileBankingUserTransactionsApi = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.mobileBankingUserTransactions, payload);
export const mobileBankingAllTransactionsApi = (payload) =>
    handleApiRequest('POST', POST_API_ENDPOINTS.mobileBankingAllTransactions, payload);
export const CreditBalanceApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.creditApi, payload);
export const getSpinResultApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.spinResult, payload);
export const reKycOtpVerifyApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.reKycOtpVerify, payload);
export const reKycSubmitAPi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.reKycSubmit, payload);
export const AddnewbankAccountApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.AddnewbankAccount, payload);
export const ListbankAccountApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.ListbankAccount, payload);
export const SetPrimarybankAccountApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.SetPrimarybankAccount, payload);
export const DeletebankAccountApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.DeletebankAccount, payload);
export const ListAllAEPSTransactionsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listAllAEPSTransactions, payload);
export const listBatchesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listBatches, payload);
export const checkCreateBatchApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkCreateBatch, payload);
export const createBatchesApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createBatches, payload);
export const updateAutoSettlementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.UpdateAutoSettlementStatus, payload);
export const profileSummmaryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.profileSummmary, payload);
export const todaySummaryApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.todaySummary, payload);
export const addTransactionQuicklyApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.addTransaction, payload);
export const listTransactionsQuicklyApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listTransactions, payload);
export const pennyDropFundManagementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.pennyDropFundManagement, payload);
export const loginTypeChangerApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.loginTypeChanger, payload);
export const premiumNotifyResponseApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.premiumNotifyResponse, payload);
export const getPremiumBcChargesNewApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.premiumBCChargesNew, payload);
export const rekycOtpSendApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.rekycOtpSend, payload);
export const getBankList = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.bankList, payload);
export const checkPermissionGet = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.checkPermission, payload);
export const uploadExcelMobileBanking = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.excelUploadMb, payload);
export const signRentalAgreementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.signRentalAgreement, payload);
export const getRentalAgreementApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.getRentalAgreement, payload);
export const digiLoanForm = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.digiloan, payload);
export const digiLoanList = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.listLoan, payload);
export const getStateApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.states, payload);
export const getDistrictApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.district, payload);
export const getCityApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.city, payload);
export const getRegistrationStatus = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkRegistrationStatus, payload);
export const svantantrInsuranceRegApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.svantantrInsuranceRegistration, payload);
export const createLeadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.createLead, payload);
export const leadListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.leadList, payload);
export const fetchMarketPlaceServicesApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.fetchMarketPlaceServices, payload);
export const fetchMarketPlaceCategoryApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.fetchMarketPlaceCategory, payload);
export const homePageInformationsApi = (payload) => handleApiRequest('GET', GET_API_ENDPOINTS.homePageInformations, payload);
export const marketPlaceSendOtpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.marketPlaceSendOtp, payload);
export const marketPlaceVerifyOtpApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.marketPlaceVerifyOtp, payload);
export const storeMarketCustomerApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.storeMarketCustomer, payload);
export const goldLeadApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.goldLead, payload);
export const goldLeadListApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.goldLeadList, payload);
export const fingpayCmsAuthLinkApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.fingpayCmsAuthLink, payload);
export const fingpayCmsListTransactionsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.fingpayCmsListTransactions, payload);
export const checkFingpayCmsStatusApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.checkFingpayCmsStatus, payload);
export const registerFingpayCmsApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.registerFingpayCms, payload);
export const travelRedirect = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.travelRedirect, payload);
export const travelLists = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.travelList, payload);
export const statusMpin = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.statusMpin, payload);
export const merchantWalletTransactions = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.merchantWalletTransactions, payload);
export const chatbotTokenApi = (payload) => handleApiRequest('POST', POST_API_ENDPOINTS.chatbotToken, payload);
